import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import { asyncActions as createSubmitActions } from './actions/Terminal.create.submit.action';
import { asyncActions as editStartActions } from './actions/Terminal.edit.start.action';
import { asyncActions as editSubmitActions } from './actions/Terminal.edit.submit.action';
import { ErrorWrapper } from 'store/base';

export const REDUCER_KEY__TERMINAL = 'terminal';

export class TerminalState {
  type?: string;
  errorWrapper?: ErrorWrapper;
  errorWrapperUser?: ErrorWrapper;
  terminalId?: string;
  loading: boolean;
}

const defaultState: TerminalState = {
  loading: false,
};
export default (state: TerminalState = defaultState, action: Action): TerminalState => {
  // Create actions

  if (isType(action, createSubmitActions.started)) {
    return { ...state, type: action.type, loading: true };
  }
  if (isType(action, createSubmitActions.done)) {
    return { ...state, type: action.type, loading: false };
  }

  if (isType(action, createSubmitActions.failed)) {
    return { ...state, type: action.type, errorWrapper: action.payload.error, loading: false };
  }

  // Edit actions
  if (isType(action, editStartActions.started)) {
    return { ...state, type: action.type, loading: true };
  }
  if (isType(action, editStartActions.done)) {
    return { type: action.type, terminalId: action.payload.result.terminalId, ...defaultState };
  }
  if (isType(action, editStartActions.failed)) {
    return { ...state, type: action.type, loading: false, errorWrapper: action.payload.error };
  }
  if (isType(action, editSubmitActions.started)) {
    return { ...state, type: action.type, loading: true };
  }
  if (isType(action, editSubmitActions.done)) {
    return { ...state, type: action.type, loading: false };
  }
  if (isType(action, editSubmitActions.failed)) {
    return { ...state, type: action.type, errorWrapper: action.payload.error, loading: false };
  }

  return state;
};
